exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in-modal .pay-in__checkbox-label {\n  color: #222c3c;\n  font-size: 0.8rem;\n}\n.pay-in-modal {\n  -ms-flex-align: start;\n      align-items: flex-start;\n  padding-top: 3rem;\n}\n.pay-in-modal .modal-dialog {\n  width: 100%;\n  max-width: 820px;\n  transition: max-width 0.3s ease;\n}\n.pay-in-modal--compact .modal-dialog {\n  max-width: 520px;\n}\n.pay-in-modal--scope .modal-dialog {\n  max-width: 650px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-efba4bec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn.vue
// module id = 1985
// module chunks = 0